import { render, staticRenderFns } from "./MgeoreptypesGrid.vue?vue&type=template&id=91aa0db6"
import script from "./MgeoreptypesGrid.vue?vue&type=script&lang=js"
export * from "./MgeoreptypesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports